import { yearSummarySchema } from '@klopotun/contracts';
import { apiRequest } from '../../../../shared/api/index.js';
import type { YearSummary } from '../../model/year-summary.js';
import type { YearSummaryDto } from '../dto/year-summary.dto.js';
import { toYearSummary } from '../mappers/year-summary.mapper.js';

type SummaryRequest = {
  year: number | null;
  month: number | null;
  category: string | null;
};

const searchOf = (request: SummaryRequest): string => {
  const params = new URLSearchParams();

  if (request.year !== null) {
    params.set('year', String(request.year));
  }

  if (request.month !== null) {
    params.set('month', String(request.month));
  }

  if (request.category !== null) {
    params.set('category', request.category);
  }

  const search = params.toString();

  return search === '' ? '' : `?${search}`;
};

const fetchSummary = async (
  request: SummaryRequest,
  signal: AbortSignal,
): Promise<YearSummaryDto> =>
  yearSummarySchema.parse(await apiRequest<unknown>(`/summary${searchOf(request)}`, { signal }));

export const getSummary = async (
  request: SummaryRequest,
  signal: AbortSignal,
): Promise<YearSummary> => toYearSummary(await fetchSummary(request, signal));
